(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('statusTextColor', statusTextColor);

    function statusTextColor(lodash) {
        return function(value) {
            var mapping = {
                'black': {
                    'text-white': [''],
                },
                'white': {
                    'text-black': [''],
                },
                'grey': {
                    'text-white': ['darkest', 'darker', 'dark'],
                    'text-black': ['base', 'light', 'lighter', 'lightest'],
                },
                'red': {
                    'text-white': ['darkest', 'darker', 'dark', 'base', 'light'],
                    'text-red-darkest': ['lighter', 'lightest'],
                },
                'orange': {
                    'text-white': ['darkest', 'darker', 'dark'],
                    'text-orange-darkest': ['base', 'light', 'lighter', 'lightest'],
                },
                'yellow': {
                    'text-white': ['darkest', 'darker'],
                    'text-yellow-darkest': ['dark', 'base', 'light', 'lighter', 'lightest'],
                },
                'green': {
                    'text-white': ['darkest', 'darker', 'dark', 'base'],
                    'text-green-darkest': ['light', 'lighter', 'lightest'],
                },
                'teal': {
                    'text-white': ['darkest', 'darker', 'dark', 'base'],
                    'text-teal-darkest': ['light', 'lighter', 'lightest'],
                },
                'blue': {
                    'text-white': ['darkest', 'darker', 'dark', 'base'],
                    'text-blue-darkest': ['light', 'lighter', 'lightest'],
                },
                'indigo': {
                    'text-white': ['darkest', 'darker', 'dark', 'base', 'light'],
                    'text-indigo-darkest': ['lighter', 'lightest'],
                },
                'purple': {
                    'text-white': ['darkest', 'darker', 'dark', 'base', 'light'],
                    'text-purple-darkest': ['lighter', 'lightest'],
                },
                'pink': {
                    'text-white': ['darkest', 'darker', 'dark', 'base', 'light'],
                    'text-pink-darkest': ['lighter', 'lightest'],
                },
            };

            var globalDefault = 'text-white';
            
            var valueParts = value.split('-');

            if (valueParts.length <= 0) {
                return globalDefault;
            } else if (valueParts.length === 1) {
                valueParts = valueParts.concat(['base']);
            }

            var mainColor = valueParts[0];
            var shadingColor = valueParts[1];

            var hasColorMap = lodash.has(mapping, mainColor);
            if (!hasColorMap) {
                return globalDefault;
            }

            var colorMap = mapping[mainColor];

            return lodash.reduce(Object.keys(colorMap), function (accum, oColorMapKeys) {
                var hasIndex = lodash.indexOf(colorMap[oColorMapKeys], shadingColor) >= 0;

                if (hasIndex) {
                    return oColorMapKeys;
                }

                return accum;
            }, globalDefault);
        };
    }
})();